import { render, staticRenderFns } from "./MenuDetails.vue?vue&type=template&id=dedeb072&scoped=true&"
import script from "./MenuDetails.vue?vue&type=script&lang=js&"
export * from "./MenuDetails.vue?vue&type=script&lang=js&"
import style0 from "./MenuDetails.vue?vue&type=style&index=0&id=dedeb072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedeb072",
  null
  
)

export default component.exports